import createGetFormSubmitErrors from './selectors/getFormSubmitErrors';
import plain from './structure/plain';

export default createGetFormSubmitErrors(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/getFormSubmitErrors.js
// module id = 1788
// module chunks = 14